export default "__VITE_ASSET__DmLr5uEQ__"